import type { MatchModelBase } from '@nf/types/odds';
import { PeriodScoresBase } from '../period-scores.base';

export class DefaultPeriodScores extends PeriodScoresBase<MatchModelBase> {
	createPeriodScores(): Array<string> {
		return [];
	}
}